'use client'

export function ServicesMarquee() {
  return (
    <section className="my-24 border-y border-border bg-secondary/40 py-6 overflow-hidden">
      <div className="flex animate-[marquee_40s_linear_infinite] whitespace-nowrap">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="flex items-center gap-12 px-6 font-display text-3xl italic md:text-5xl">
            <span>Couture Color</span>
            <span className="text-rose-gold">·</span>
            <span>Precision Cut</span>
            <span className="text-rose-gold">·</span>
            <span>Glow Rituals</span>
            <span className="text-rose-gold">·</span>
            <span>Bridal Atelier</span>
            <span className="text-rose-gold">·</span>
          </div>
        ))}
      </div>
      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>
  );
}
